import { useNavigate } from 'react-router-dom';
import {
  BreadcrumbNav,
  BreadcrumbLink,
  BreadcrumbSep,
  BreadcrumbText,
} from '../../WorkspaceHeaderLayout.styles';
import { BreadcrumbSegment } from '../workspaceHeaderNavigationConfig';

type Props = {
  segments: BreadcrumbSegment[];
};

export const WorkspaceHeaderCompactBreadcrumb: React.FC<Props> = ({
  segments,
}) => {
  const navigate = useNavigate();

  return (
    <BreadcrumbNav aria-label="Breadcrumb">
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1;
        return (
          <span key={`${segment.label}-${index}`}>
            {index > 0 && <BreadcrumbSep>/</BreadcrumbSep>}
            {segment.path && !isLast ? (
              <BreadcrumbLink
                type="button"
                onClick={() => navigate(segment.path!)}
              >
                {segment.label}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbText $isCurrent={isLast}>{segment.label}</BreadcrumbText>
            )}
          </span>
        );
      })}
    </BreadcrumbNav>
  );
};
